import OfferingInfo from '../../../models/OfferingInfo'
import OfferingDropdownGenerator from '../../../util/OfferingDropdownGenerator'
import './OfferingDropdown.css'

interface OfferingDropdownProps {
    offeringInfo: OfferingInfo | null
    ref: React.RefObject<HTMLDivElement | null>
}

const sectionsGenerator = new OfferingDropdownGenerator()

function OfferingDropdown({offeringInfo, ref}: OfferingDropdownProps){

    let sections
    if(offeringInfo){
        sections = sectionsGenerator.generateSectionComponents(offeringInfo)
    }

    return (
        <div className='expanded-panel' ref={ref}>
          <div className="offering-expanded-container">
            <h3 className="offering-expanded-title">{offeringInfo?.title}</h3>
                {sections}
            <div className='offering-links'>
                <div className='offering-link'>
                    <h4>Interested in Joining?</h4>
                    <a className='button apply-button' href={offeringInfo?.offeringLink}target='new'>Apply Now</a>
                </div>
                <div className='offering-link'>
                    <h4>Let's See if Coaching is a fit for YOU!</h4>
                    <a className='button apply-button' href={"https://calendly.com/trishasomerscoaching/30min" } target='new'>Schedule a call</a>
                </div>
            </div>
          </div>
        </div>
    )
}

export default OfferingDropdown